import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export interface LoadingBackdropProps {
  readonly refreshing: boolean;
}
export default function LoadingBackdrop(props: LoadingBackdropProps) {
  return (
    <div>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={props.refreshing}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
